var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

// We retry:
//  - when receiving a rate limiting response
//  - on network failures due to timeouts
var shouldRetry = function shouldRetry(_ref) {
  var _ref$response = _ref.response,
      response = _ref$response === void 0 ? {} : _ref$response,
      _ref$error = _ref.error,
      error = _ref$error === void 0 ? {} : _ref$error;
  return response.status === RATE_LIMIT_STATUS || RETRY_ERROR_CODES.has(error.code);
};

var waitForRetry =
/*#__PURE__*/
function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(response) {
    var delay;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            delay = getDelay(response);
            _context.next = 3;
            return sleep(delay);

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function waitForRetry(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var getDelay = function getDelay(response) {
  if (response === undefined) {
    return DEFAULT_RETRY_DELAY;
  }

  var rateLimitReset = response.headers.get(RATE_LIMIT_HEADER);

  if (!rateLimitReset) {
    return DEFAULT_RETRY_DELAY;
  }

  return Math.max(Number(rateLimitReset) * SECS_TO_MSECS - Date.now(), MIN_RETRY_DELAY);
};

var sleep = function sleep(ms) {
  return new Promise(function (resolve) {
    setTimeout(resolve, ms);
  });
};

var DEFAULT_RETRY_DELAY = 5e3;
var MIN_RETRY_DELAY = 1e3;
var SECS_TO_MSECS = 1e3;
var MAX_RETRY = 10;
var RATE_LIMIT_STATUS = 429;
var RATE_LIMIT_HEADER = 'X-RateLimit-Reset';
var RETRY_ERROR_CODES = new Set(['ETIMEDOUT']);
module.exports = {
  shouldRetry: shouldRetry,
  waitForRetry: waitForRetry,
  MAX_RETRY: MAX_RETRY
};